import React from 'react';
import { styles } from './PrintFormStructure.styles';
import { PropTypes } from 'prop-types';
import GroupType from './GroupType';
import { renderFormValue } from './GetFormValue';
import NonField from './NonFields';
export const lengthContent = (label, value) => {
    const length = label?.length + value?.length;
    const column = length >= 38 && length <= 76 ? 2 : length >= 76 ? 3 : 1;
    const isLong = length >= 124;
    return { column, isLong };
};
const InputContainer = ({ field, entry, prevField, isRtl }) => {
    const isGroup = field.data_type === 'group';
    const hasParent = field.parent;
    let breakLine = false;
    if (field?.presentation) {
        const presentation = field?.presentation;
        const group = presentation.link?.group;
        const prevGroup = prevField?.presentation?.link?.group;
        const newLine = presentation.hasPrecedingBreakLine;
        if ((group && group !== prevGroup) || newLine || (group && !prevGroup)) {
            breakLine = true;
        }
    }
    const value = renderFormValue(field, entry) || '-';
    const { column, isLong } = lengthContent(field?.label, value);

    const classes = styles({
        isGroup,
        hasParent,
        breakLine,
        column,
        isLong,
        isRtl
    });

    return (
        <>
            {field.data_type === 'none' ? (
                <NonField field={field} />
            ) : (
                <>
                    {breakLine && <hr className={classes.break} />}
                    <div className={isGroup && !hasParent ? classes.groupContainer : classes.item}>
                        <div className={classes.entryWrapper}>
                            <span className={isGroup && classes.groupTitle}>{field?.label}</span>
                            {!isGroup && (
                                <>
                                    <span className={classes.doubleDot}>:</span>{' '}
                                    <span>{value}</span>
                                </>
                            )}
                        </div>
                        {isGroup ? <GroupType field={field} entry={entry} /> : null}
                    </div>
                </>
            )}
        </>
    );
};
InputContainer.propTypes = {
    fields: PropTypes.object,
    field: PropTypes.object,
    entry: PropTypes.object,
    prevField: PropTypes.object,
    isRtl: PropTypes.bool
};
export default InputContainer;
